<div class="container py-5">
  <div class="row">
    <div class="col-12 mb-5">
      <h1 class="text-center fw-bold">
        Hey! we have moved to: <a href="https://www.travelgate.com/">www.travelgate.com</a>
      </h1>
      <h2 class="text-center mb-0 text-secondary">Please update your bookmarks</h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-7 col-md-9 col-12 mb-5">
        <img style="width: 100%" src="/assets/img/pages/xml_redirect/moving_tgx.svg" alt="XMLTravelgate Truck" />
      </div>
    </div>
    <div class="col-12 mb-3">
      <h3 class="text-center fw-bold">
        <i class="fas fa-check me-1"></i> New features, new design, new UX experience...
        <i class="fas fa-heart text-danger" style="transform: translateY(-15px) rotate(10deg)"></i>
      </h3>
    </div>
  </div>
</div>
